import {
  permissionValue,
  type ClientPermissionKey,
  type ClientUserPermissions,
} from "@/lib/auth/client-permissions";
import { tabHasData } from "@/lib/dashboard/dashboard-views";

interface ClientNavVisibilityContext {
  demoMode: boolean;
  hasContent?: boolean;
  isStaff: boolean;
  permissions: ClientUserPermissions | null;
}

/** Keep client navigation visibility aligned with the permission used by its route guard. */
export function canShowClientNavItem(
  permission: ClientPermissionKey,
  context: ClientNavVisibilityContext,
): boolean {
  if (context.demoMode || context.isStaff) return true;
  return context.hasContent !== false &&
    context.permissions !== null &&
    permissionValue(context.permissions, permission);
}

const HEALTH_PROVIDERS = new Set([
  "uptime_builtin",
  "pagespeed",
  "site_audit",
  "link_checker",
  "seo_crawl",
  "accessibility",
  "ai_search_health",
]);

/** Content test for standard dashboards using the complete company provider set. */
export function clientDashboardNavHasData(view: string, providers: Set<string>): boolean {
  if (view === "overview") return providers.size > 0;
  if (view === "health") {
    return [...HEALTH_PROVIDERS].some((provider) => providers.has(provider));
  }
  return tabHasData(view, providers);
}
